import * as configurations from '../configuration/servers';
import currentConfig from '../configuration/config.json';
import StringProcessingService from './string-processing-service';
import subdomainConfig from '../configuration/subdomains.json';

const languageList = require('../configuration/languages/list.json')

const stringProcessingService = new StringProcessingService();

let debug = false;
let currentServer = configurations[currentConfig.currentServer];
let siteUrl = '';

if(typeof window !== "undefined"){
    siteUrl = window.location.protocol + "//" + window.location.hostname + "/"; 
} 

let splitedHostName = typeof window !== "undefined" ? window.location.hostname.split('.') : [];
let languagePrefix = 'en';

let currentLanguage = null;
let subdomain = null;

const detectLanguageFromPath = (pathname = '/') => {
    const firstPathSegment = pathname.split('/').filter(Boolean)[0];
    const detectedLanguage = languageList.find((language) => language.name === firstPathSegment);
    return detectedLanguage || languageList[0];
};


if (typeof window !== "undefined") {
    currentLanguage = detectLanguageFromPath(window.location.pathname);
    languagePrefix = currentLanguage.name;

    // Keep custom subdomains support for project pages (non-language prefixes).
    if (splitedHostName.length > 2 && splitedHostName[0] !== 'smartluxe') {
        const hostPrefix = splitedHostName[0];
        const isLanguageSubdomain = languageList.some((language) => language.name === hostPrefix);
        if (!isLanguageSubdomain) {
            subdomain = hostPrefix;
        }
    }
}

if(!currentLanguage) document.location.href = "https://ngirealty.com/";

if(typeof localStorage !== "undefined"){
    localStorage.setItem('lang', languagePrefix);
}

if (siteUrl.includes('axis')) {
    currentServer = configurations["axis"];

} else if (siteUrl.includes('onserv')) {
    currentServer = configurations["onserv"];
   // siteUrl = configurations["onserv"].serverApi;

} else if (siteUrl.includes('track21')) {
    currentServer = configurations["track"];

}
else {
    currentServer = configurations["prod"];
}

export default class ConfigurationService {

    getCurrentServer() {
        if (debug) {
            console.log(currentServer);
        }
        return currentServer;
    }

    getCurrentSite() {
        return siteUrl;
    }

    getDomain(){
        if (stringProcessingService.GetParamsFromUrl().get('debug')) return "http://ngi.test/";
        // else  return 'http://ngi.test/';
        else  return 'https://ngirealty.com/';
    }

    getSubdomain(){
        return subdomain;
    }

    checkLanguage(currentPage){
       if( currentLanguage && !currentLanguage.global){
            let isWhiteListPage = currentLanguage.whiteList.find((item)=>{
                return item === currentPage;
            })
            if(!isWhiteListPage) document.location.href = "https://ngirealty.com/";
        
       }
    }

    switchLanguage(lang) {
        switch (lang) {
            case 'en': {
                localStorage.setItem('lang', 'en');
                break;
            }
            case 'pt': {
                localStorage.setItem('lang', 'pt');
                break;
            }
            case 'es': {
                localStorage.setItem('lang', 'es');
                break;
            }
            case 'he': {
                localStorage.setItem('lang', 'he');
                break;
            }
            default: {
                localStorage.setItem('lang', 'en');
                break;
            }
        }
    }

    getCurrentLanguagePrefix() {
        return languagePrefix;
    }

    static getCurrentLanguagePrefix() {
        return languagePrefix;
    }
    
    static getBaseUrl() {
        return 'https://smartluxe.com/';
    }

    checkDomainName(){
        if(document.location.hostname.includes('www.')){
            document.location.replace(document.location.href.replace('www.',''))
        }

        return null;
    }

    checkSubdomainPage(currentPage){
       if(!subdomainConfig.allowedSubdomainPages.some((subdomainPage)=> currentPage == subdomainPage)){
            document.location.href = "https://smartluxe.com/";
       }
    }
}

